const DISPLAY_DEDUPE_MS = 3000;
const seenNotifications = new Map();
let focusTrackingInitialized = false;
let lastWindowFocused = true;

function currentPathname() {
  if (typeof window === 'undefined') return '';
  return window.location?.pathname || '';
}

function syncWindowFocusState(value) {
  lastWindowFocused = value;
}

function initFocusTracking() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (focusTrackingInitialized) return;

  focusTrackingInitialized = true;
  lastWindowFocused =
    typeof document.hasFocus === 'function' ? document.hasFocus() : true;

  window.addEventListener('focus', () => syncWindowFocusState(true));
  window.addEventListener('blur', () => syncWindowFocusState(false));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      syncWindowFocusState(false);
    } else if (typeof document.hasFocus === 'function') {
      syncWindowFocusState(document.hasFocus());
    }
  });
}

export function isPageForeground() {
  if (typeof document === 'undefined' || typeof window === 'undefined') return true;
  initFocusTracking();
  const visible = document.visibilityState === 'visible';
  const focused = lastWindowFocused;
  return visible && focused;
}

function payloadData(payload = {}) {
  return payload?.data || {};
}

export function notificationEventName(payload = {}) {
  const data = payloadData(payload);
  return payload?.event || payload?.type || data?.event || data?.type || '';
}

export function notificationIdentity(payload = {}) {
  const data = payloadData(payload);
  return (
    data?.message?.id ||
    data?.thread_id ||
    data?.live_session_id ||
    data?.order_id ||
    data?.buyer_request_id ||
    data?.shop_response_id ||
    data?.shop_id ||
    data?.click_action ||
    'global'
  );
}

export function notificationIsSilent(payload = {}) {
  return Boolean(payload?.silent || payloadData(payload)?.silent);
}

export function suppressInActiveView(payload = {}) {
  if (!isPageForeground()) return false;

  const event = notificationEventName(payload);
  const data = payloadData(payload);
  const pathname = currentPathname();

  if (event === 'message_thread_updated' && data?.thread_id) {
    return pathname === `/messages/${data.thread_id}` || pathname === `/buyer/messages/${data.thread_id}`;
  }

  if (String(event).startsWith('live_session_') && data?.live_session_id) {
    return pathname === `/live_sessions/${data.live_session_id}`;
  }

  return false;
}

export function shouldPlayNotificationSound(payload = {}) {
  return !notificationIsSilent(payload);
}

export function shouldDisplayInAppNotification(payload = {}, { dedupeMs = DISPLAY_DEDUPE_MS } = {}) {
  if (notificationIsSilent(payload) || !isPageForeground() || suppressInActiveView(payload)) return false;

  const event = notificationEventName(payload);
  if (!event) return false;

  const key = `${event}:${notificationIdentity(payload)}`;
  const now = Date.now();
  const lastSeen = seenNotifications.get(key) || 0;

  if (now - lastSeen < dedupeMs) return false;

  seenNotifications.set(key, now);
  return true;
}

export function resetInAppNotificationState() {
  seenNotifications.clear();
  focusTrackingInitialized = false;
  lastWindowFocused = true;
}
